<template lang="pug">
g-data-table.confirmationTable(
  :items="pagination.data",
  :options.sync="options",
  :server-items-length="pagination.total",
  v-model="selected",
  v-bind="{ headers, loading }"
)
  //- show-select,
  template(v-slot:item.SHO_Additional_Info.Vendor_ID="{ item, header }")
    .item-extra {{ $getExtraFieldValue(item, header)}}
  template(v-slot:item.Shipment_Updates_Info.ActualCollection="{ item, header }")
    .item-extra {{ $getExtraFieldValue(item, header)}}
  template(v-slot:item.Shipment_Updates_Info.PlanEndDate="{ item, header }")
    .item-extra {{ $getExtraFieldValue(item, header)}}
  template(v-slot:item.Shipment_Updates_Info.ActualDeliverDate="{ item, header }")
    .item-extra {{ $getExtraFieldValue(item, header)}}
  template(v-slot:top)
    v-row.table__title
      v-col.h2.primary--text {{ $t('ShipmentManagement.shipmentManagement') }}
    v-row.table__top
      v-col.py-0
        app-entity-search(
          :criteria="[]",
          @pagination="pagination = $event",
          :loads="loads",
          :entity="entity",
          :rowsPerPage="options.itemsPerPage || null"
          :wheres="pagination.where"
        )
</template>

<script>
import axios from 'axios';

export default {
  name: 'ConfirmationTable',
  data: () => ({
    options: {},
    selected: [],
    // Added wheres here for initial pagination
    // sent also to entity search
    pagination: {
      where: ['x => x.Status.Name != "CANCELLED" and x.Status.Name != "Cancel" and x.Status.Name != "Draft" and (x.ExtraData.Any(ed => ed.key == "Shipment_Updates_Info.ActualDeliverDate") == false or x.ExtraData.Any(ed => ed.key == "Shipment_Updates_Info.ActualDeliverDate" && ed.Datetime != null && ed.Datetime.Value.AddDays(30) >= ExpHelpers.Now))']
    },
    // Same loads as endpoint call on load()
    loads: ['User', 'ExtraData', 'PartyFrom', 'Status'],
    loading: true,
  }),
  watch: {
    options: {
      handler(options) {
        this.load(options);
      }
    }
  },
  computed: {
    headers() {
      return [
        { text: this.$t('ShipmentManagement.vendor'), value: "SHO_Additional_Info.Vendor_ID", sortable: false },
        { text: this.$t('ShipmentManagement.shipper'), value: "user.fullName" },
        { text: this.$t('ShipmentManagement.shipmentNumber'), value: "externalId" },
        { text: this.$t('ShipmentManagement.creationDate'), value: "createdAt", type: "DateTime" },
        { text: this.$t('ShipmentManagement.shipmentStatus'), value: "status.name" },
        { text: this.$t('ShipmentManagement.readyToPickup'), value: "datePickupFrom", type: "DateTime" },
        { text: this.$t('ShipmentManagement.shippedDate'), value: "Shipment_Updates_Info.ActualCollection", sortable: false, type: "DateTime" },
        { text: this.$t('ShipmentManagement.shipFromCountry'), value: "partyFrom.countryName" },
        { text: this.$t('ShipmentManagement.deliveryDate'), value: "Shipment_Updates_Info.PlanEndDate", sortable: false, type: "DateTime" },
        { text: this.$t('ShipmentManagement.actualDeliveryDate'), value: "Shipment_Updates_Info.ActualDeliverDate", sortable: false, type: "DateTime" },
      ]
    },
    entity() {
      return this.$findEntity('Shipment');
    },
  },
  methods: {
    getPagination(options = null, where = null) {
      options = options || this.options;
      if (!_.keys(options).length) return;
      // console.log('OPTS ', options)
      return {
        params: {
          page: options.page,
          pageSize: options.itemsPerPage,
          orderBy: options.sortBy[0],
          desc: options.sortDesc[0],
          where: where,
        }
      };
    },
    async load(options = null) {
      try {
        this.loading = true;
        const pagination = this.getPagination(options, this.pagination.where);
        let endpoint = this.$fetchLoad(
          "Shipment",
          true,
          "user",
          "status",
          "partyFrom",
          "extraData",
        );
        this.pagination = (await axios.get(endpoint, pagination)).data;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
